var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalCoaches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_204_3455",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 38.5V1.5H1.5V38.5H38.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navi",
    mask: "url(#mask0_204_3455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 1.17188C7.54594 1.17188 1.17188 7.02125 1.17188 14.1406C1.17188 17.6888 2.73695 20.9009 5.26727 23.232L1.17188 27.0312H15.3125C23.0791 27.0312 29.375 21.2598 29.375 14.1406C29.375 7.02125 23.0791 1.17188 15.3125 1.17188Z",
    stroke: "#202117",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3672 13.6996C34.8333 15.4671 38.8285 20.2439 38.8285 25.8594C38.8285 29.4074 37.2633 32.6978 34.7331 35.0288L38.8285 38.8281H24.6879C17.3522 38.8281 11.3285 33.6013 10.6826 27.0313",
    stroke: "#202117",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28125 8.28125H22.3438",
    stroke: "#202117",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28125 12.9688H22.3438",
    stroke: "#202117",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28125 17.6562H22.3438",
    stroke: "#202117",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCoaches);
export default __webpack_public_path__ + "static/media/modal-coaches.8c550ef174f356bd65e63d0b06231fbf.svg";
export { ForwardRef as ReactComponent };